import React, {useEffect} from "react";
import {Outlet, useLocation} from "react-router-dom";

import {Header, Title, TopBar} from "@/components";
import {TopBarItem} from "@/components/TopBar/types";

import {useCurrentWidth} from "@/hooks";
import {MediaBreakPoints} from "@/resources/constants";

import {useAppDispatch} from "@redux/store";

import {ServicesPropsType} from "./types";
import styles from "./Services.module.scss"
import servicesImage from "@/assets/img/services-main-image.png";

export const Services: React.FC<ServicesPropsType> = ({ title }) => {
	const dispatch = useAppDispatch();
	const location = useLocation();
	const windowWidth = useCurrentWidth();
	const breakPoint = MediaBreakPoints.MOBILE_LARGE;

	const topBarItems: TopBarItem[] = [
		{ id: "racket-calendar", text: "Аренда ракеток", path: "racket-calendar", description: "Арендуйте необходимый для игры инвентарь" },
		{ id: "products", text: "Товары", path: "products", description: "Дополнительные товары для вашего комфорта" },
		{ id: "tennis-school", text: "Школа тенниса", path: "tennis-school", description: "Групповые тренировки по теннису и padel для взрослых и детей от 3-х лет" },
		{ id: "personal-trainings", text: "Персональные тренировки", path: "personal-trainings", description: "Персональные тренировки для спортсменов и любителей" },
		{ id: "storage", text: "Хранение спортивного инвентаря", path: "storage", description: "Храните необходимый инвентарь в клубе" },
	];

	useEffect(() => {

	}, [location.pathname, dispatch]);

	const handleItemClick = () => {

	};

	const currentTitle = topBarItems.find(item =>
		location.pathname.includes(`/services/${item.path}`)
	)?.text || title;

	return (
		<>
			<Header title={currentTitle} />
			<main>
				<section className="container">
					<Title>{title}</Title>
					{windowWidth > breakPoint ? (
						<div className={styles.wrapper}>
							<TopBar
								items={topBarItems}
								basePath="/services"
								onItemClick={handleItemClick}
								breakPoint={breakPoint}
							/>
							<div className={styles.content}>
								<Outlet/>
							</div>
						</div>
					) : (
						location.pathname === "/services" && windowWidth < breakPoint ? (
							<>
								<img src={servicesImage} alt="Сервис" className={styles.servicesImage} />
								<TopBar
									items={topBarItems}
									basePath="/services"
									onItemClick={handleItemClick}
									breakPoint={breakPoint}
								/>
							</>
						) : (
							<div className={styles.wrapper}>
								<Outlet/>
							</div>
						)
					)}
				</section>
			</main>
		</>
	);
};

